export default "__VITE_ASSET__1f17904a__"